

import React from 'react'

const DashboardCards = ({ Heading, Amount, Icon }) => {
  const amountText = Amount ?? 'Not available';
  const amountLength = String(amountText).length;

  return (
    <div className="Card-Parent flex p-4 max-md:p-3 justify-between items-center w-full bg-[#fff] rounded-2xl shadow-md">
      <div className="Card-Text flex flex-col space-y-2">
        <p className="text-sm max-md:text-sm text-grey4">{Heading || 'Not available'}</p>
        <div className="flex justify-start items-end flex-1">
          <h1 className={`max-md:text-md text-xl ${amountLength > 5 ? 'text-md' : 'text-xl'}`}>
            {amountText}
          </h1>
        </div>
      </div>
      <div className="h-12 w-12 rounded-lg bg-[#257F34] flex items-center justify-center">
        <Icon className="h-6 w-6 text-[#fff]" />
      </div>
    </div>
  );
};

export default DashboardCards;
